"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DriveSessionTypesModel = /** @class */ (function () {
    function DriveSessionTypesModel($http, APPURL) {
        this.$http = $http;
        this.APPURL = APPURL;
        this.URLS = {
            FETCH: APPURL + "/api/v1/session-types",
            UPDATE: APPURL + "/api/v1/session-types",
            CREATE: APPURL + "/api/v1/session-types",
        };
        this.data = [];
        this.extract = this.extract.bind(this);
        this.cacheResults = this.cacheResults.bind(this);
    }
    DriveSessionTypesModel.prototype.extract = function (result) {
        return result.data;
    };
    DriveSessionTypesModel.prototype.cacheResults = function (result) {
        this.data = this.extract(result);
        return this.data;
    };
    DriveSessionTypesModel.prototype.getByID = function (id) {
        return this.$http
            .get(this.URLS.FETCH + "/" + id)
            .then(this.cacheResults);
    };
    DriveSessionTypesModel.prototype.get = function () {
        return this.$http
            .get(this.URLS.FETCH)
            .then(this.cacheResults);
    };
    DriveSessionTypesModel.prototype.update = function (request) {
        return this.$http
            .put(this.URLS.FETCH + "/" + request.id, request)
            .then(this.cacheResults);
    };
    DriveSessionTypesModel.prototype.insert = function (request) {
        return this.$http
            .post(this.URLS.FETCH, request)
            .then(this.cacheResults);
    };
    DriveSessionTypesModel.prototype.remove = function (sessionType) {
        return this.$http
            .delete(this.URLS.FETCH + "/" + sessionType.id)
            .then(this.cacheResults);
    };
    return DriveSessionTypesModel;
}());
DriveSessionTypesModel.$inject = ["$http", "APPURL"];
exports.default = DriveSessionTypesModel;
